import { render } from "./App.vue?vue&type=template&id=62c65709"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=62c65709&lang=css"
script.render = render

export default script